import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import AppWrapper from "./app/AppWrapper";
import reportWebVitals from "./app/reportWebVitals";
import AppProviders from "./app/providers/AppProviders";
import ErrorBoundary from "./app/providers/ErrorBoundary";
import { redirectToSSOLogin } from "./utils/ssoRedirect";

// cuando vence la sesión (401), redirigir al login SSO
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  const res = await originalFetch(...args);
  if (res && res.status === 401) {
    redirectToSSOLogin();
  }
  return res;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
        <AppProviders>
          <AppWrapper></AppWrapper>
        </AppProviders>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
